import api from './api';

const getCategories = async (params = {}) => {
    const response = await api.get('/board-categories', { params });
    return response.data;
};

const getCategoryById = async (id) => {
    const response = await api.get(`/board-categories/${id}`);
    return response.data;
};

const getTestSeries = async (boardCategoryId) => {
    const response = await api.get('/mcq/practice-sets', { params: { boardCategoryId } });
    return response.data.practiceSets || [];
};

// Gated — caller must handle a 403 (requiresPurchase) from the response.
const getTestSeriesQuestions = async (practiceSetId) => {
    const response = await api.get(`/board-quiz/test-series/${practiceSetId}`);
    return response.data;
};

const createBoardOrder = async (boardCategoryId, couponCode) => {
    const response = await api.post('/board-orders/create-order', { boardCategoryId, couponCode });
    return response.data;
};

const verifyBoardOrder = async (payload) => {
    const response = await api.post('/board-orders/verify', payload);
    return response.data;
};

const submitBoardQuiz = async (practiceSetId, answers, timeTaken) => {
    const response = await api.post('/board-quiz/submit', { practiceSetId, answers, timeTaken });
    return response.data;
};

// Public — no purchase/login required to view rankings.
const getBoardLeaderboard = async (practiceSetId) => {
    const response = await api.get(`/board-quiz/leaderboard/${practiceSetId}`);
    return response.data;
};

const boardService = {
    getCategories,
    getCategoryById,
    getTestSeries,
    getTestSeriesQuestions,
    createBoardOrder,
    verifyBoardOrder,
    submitBoardQuiz,
    getBoardLeaderboard
};

export default boardService;
